import { render, staticRenderFns } from "./BaseSavingOverlay.vue?vue&type=template&id=776e7fc6&"
import script from "./BaseSavingOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseSavingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseSavingOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports